import React, { Dispatch, SetStateAction } from 'react';
import { View } from 'react-native';
import { translate } from '../../../services/translate';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import MyAppText from '../../../components/MyAppText';
import UnitFinishEarlyDropdown from '../../../components/app-agent/UnitFinishEarlyDropdown';
import { useAuth } from '../../../context/Auth';
import FormInput from '../../../components/FormInput';
import BasicModal from '../../../components/BasicModal';

interface ModalProps {
    isModalVisible: boolean;
    setModalVisible: Dispatch<SetStateAction<boolean>>;
    onClose: () => void;
    onSubmit: () => void;
    finishEarlyReason: number;
    setFinishEarlyReason: Dispatch<SetStateAction<number>>;
    needFinishReason: boolean;
    unitId: number;
    dailyPoliceLog: string;
    setDailyPoliceLog: Dispatch<SetStateAction<string>>;
    observations: string;
    setObservations: Dispatch<SetStateAction<string>>;
}

export default function FinishUnitModal({ onClose, onSubmit, finishEarlyReason, setFinishEarlyReason, needFinishReason, isModalVisible, setModalVisible, unitId, dailyPoliceLog, setDailyPoliceLog, observations, setObservations }: ModalProps) {
    const { styles, theme } = useStyles(styleSheet);
    const { user: authenticatedUser } = useAuth();

    if (!authenticatedUser || unitId === 0) {
        return;
    }

    function isSaveButtonDisabled() {
        if (dailyPoliceLog === '') {
            return true;
        }

        if (needFinishReason && !finishEarlyReason) {
            return true;
        }

        return false;
    }

    return (
        <BasicModal
            isModalVisible={isModalVisible}
            setModalVisible={setModalVisible}
            title={translate('unitDeactivation')}
            width='large'
            mobileHeight='fit'
            cancelButton={{
                onClick: () => {
                    setFinishEarlyReason(0);
                    onClose();
                }
            }}
            primaryButton={{
                text: translate('save'),
                disabled: isSaveButtonDisabled(),
                onClick: () => {
                    onSubmit();
                    onClose();
                }
            }}
        >
            <>
                {needFinishReason && <View style={[styles.viewStyle, { zIndex: 2 }]}>
                    <View style={[{ flexDirection: 'row', columnGap: 5 }]}>
                        <MyAppText style={styles.inputLabelStyle}>{translate('unitDeactivationReason')}</MyAppText>
                        {needFinishReason ?
                            <MyAppText style={{ color: theme.colors.errors['300'] }}>(*)</MyAppText>
                            : null}
                    </View>
                    <UnitFinishEarlyDropdown
                        label=''
                        value={finishEarlyReason}
                        setValue={setFinishEarlyReason}
                        unitId={unitId}
                    />
                </View>}
                <FormInput
                    label={translate('dailyPolicingLog')}
                    placeholder={translate('dailyPolicingLog')}
                    value={dailyPoliceLog}
                    required
                    multiline={true}
                    onChangeText={(val) => setDailyPoliceLog(val)}
                    labelStyle={styles.inputLabelStyle}
                    viewStyle={styles.viewStyle}
                />

                <FormInput
                    label={translate('observations')}
                    placeholder={translate('observations')}
                    value={observations}
                    multiline={true}
                    onChangeText={(val) => setObservations(val)}
                    labelStyle={styles.inputLabelStyle}
                    viewStyle={styles.viewStyle}
                />
            </>
        </BasicModal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    inputLabelStyle: {
        fontSize: 14,
        fontWeight: '600',
        flexWrap: 'wrap',
        color: theme.colors.modal.header,
        marginBottom: 8,
    },
    viewStyle: {
        flexDirection: 'column',
        rowGap: 8
    }
}));
